import { Button, Card } from 'design-system';
import { MapPinHouse } from 'lucide-react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import styles from './Card.module.css';

const CardProps = (props) => {
  const navigate = useNavigate();

  const goto = () => {
    navigate(props.url);
  };

  return (
    <Card className={styles['card']}>
      <div className={styles['image-container']}>{props.logo}</div>
      <div className={styles['name']}>{props.name}</div>
      <div className={styles['country']}>
        <MapPinHouse size={16} style={{ color: 'red' }} /> {props.countryName}
      </div>
      <Button onClick={goto} block type="primary">
        <FormattedMessage id={props.ctaMessageId || 'visit'} defaultMessage="Visit" />
      </Button>
    </Card>
  );
};

export default CardProps;
